import jwt from 'jsonwebtoken'
import LocalStorageService from '../services/LocalStorageService';

class LocalStorageFactory {
    static instance () {
        return new LocalStorageService({ jwt })
    }
}

export default LocalStorageFactory